import { render, staticRenderFns } from "./CurrencyAggregationComponent.vue?vue&type=template&id=bde578e8"
import script from "./CurrencyAggregationComponent.vue?vue&type=script&lang=ts"
export * from "./CurrencyAggregationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports